import { useEffect, useState } from "react";
import { getLoggedinUser } from "../../helpers/api_helper";

const useProfile = () => {
  const userProfileSession = getLoggedinUser();
  var token =
  userProfileSession &&
  userProfileSession["token"];
  const [loading, setLoading] = useState(userProfileSession ? false : true);
  const [userProfile, setUserProfile] = useState(
    userProfileSession ? userProfileSession : null
  );

  useEffect(() => {
    const userProfileSession = getLoggedinUser();
    var token =
      userProfileSession &&
      userProfileSession["token"];
    setUserProfile(userProfileSession ? userProfileSession : null);
    setLoading(token ? false : true);
    
    // Listen for storage changes (when OAuth sets sessionStorage)
    const handleStorageChange = () => {
      const updatedUser = getLoggedinUser();
      const updatedToken = updatedUser && updatedUser["token"];
      setUserProfile(updatedUser ? updatedUser : null);
      setLoading(updatedToken ? false : true);
    };
    
    window.addEventListener('storage', handleStorageChange);
    
    // Also listen for custom event when sessionStorage is updated in same tab
    window.addEventListener('authUserUpdated', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('authUserUpdated', handleStorageChange);
    };
  }, []);


  return { userProfile, loading,token };
};

export { useProfile };